import React, { useMemo } from "react";
import PropTypes from "prop-types";

import MegaMenuItemPresenter from "presenters/MegaMenuItemPresenter";
import { useAlgolia } from "hooks";

import useStyles from "./useStyles";
import MenuItem from "./components/MenuItem";

const Navigation = ({ menuItems }) => {
  const classes = useStyles();
  const { clearAllFiltersByPath } = useAlgolia();

  const mainMenuLinks = useMemo(
    () => menuItems?.map((item) => MegaMenuItemPresenter.linkTo(item.menu)).filter(Boolean) || [],
    [menuItems],
  );

  return (
    <div className={classes.root}>
      {menuItems &&
        menuItems.map((item) => (
          <MenuItem
            key={item.name}
            menuItem={item.menu}
            mainMenuLinks={mainMenuLinks}
            onClick={() => clearAllFiltersByPath({ path: MegaMenuItemPresenter.linkTo(item.menu) })}
          />
        ))}
    </div>
  );
};

Navigation.propTypes = {
  menuItems: PropTypes.arrayOf(MegaMenuItemPresenter.shape()),
};

export default Navigation;
